import * as React from 'react'
import { MatchPairProps } from '../typings'
import { LocationSelector } from './LocationSelector'

import Divider from '@mui/material/Divider'

export const SelectionHeader: React.FC<MatchPairProps> = (props) => (
  <>
    <LocationSelector {...props} />
    <Divider sx={props.styles.divider} />
  </>
)
SelectionHeader.displayName = 'SelectionHeader'
